import { render, staticRenderFns } from "./Page2Accordeon.vue?vue&type=template&id=03adccd9&"
import script from "./Page2Accordeon.vue?vue&type=script&lang=js&"
export * from "./Page2Accordeon.vue?vue&type=script&lang=js&"
import style0 from "./Page2Accordeon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports